import React, { useCallback, useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { ShowExceptionError } from 'views/components/molecules/ShowExceptionError';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { ROUTER_PATH } from 'views/constants';
import { localeIds } from 'locals';
import { buildErrorDiagnostics } from 'models/Error/diagnostics';

function hintMessageLocaleId(error: Error): string | undefined {
  switch (error.message) {
    case 'The operation is insecure.':
      return localeIds.error.hint.cookieOff;
    case 'QuotaExceededError: DOM Exception 22':
      return localeIds.error.hint.privateBrowser;
  }

  return undefined;
}

type HandleExceptionErrorPageProps = {
  error: Error;
  componentStack?: string;
};

export const HandleExceptionErrorPage: React.FC<
  HandleExceptionErrorPageProps
> = ({ error, componentStack }) => {
  const [sentryId, setSentryId] = useState<string | undefined>(undefined);
  const hintLocaleId = hintMessageLocaleId(error);
  const isSendToSentry = hintLocaleId === undefined; // hint messageがある場合はSentryにエラーを送らない

  if (isSendToSentry) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      const eventId = Sentry.captureException(error, {
        // minify により message もスタックも解決できないイベントの切り分けに利用する
        extra: buildErrorDiagnostics(error, componentStack),
      });
      setSentryId(eventId);
    }, [error, componentStack]);
  }

  const handleBack = useCallback(() => {
    location.href = ROUTER_PATH.home;
  }, []);

  return (
    <DefaultTemplate headerText="">
      <ShowExceptionError
        error={error}
        sentryId={sentryId}
        hintLocaleId={hintLocaleId}
        onBack={handleBack}
      />
    </DefaultTemplate>
  );
};
